module.exports = __webpack_public_path__ + "static/sitemap-4a0b0347bd5661598cd5ea26b4945d8e.png";